import EmojiMartData from '@emoji-mart/data'

export const emojisData = JSON.parse(JSON.stringify(EmojiMartData)) as typeof EmojiMartData

emojisData.categories.unshift({
  id: 'favorites',
  emojis: ['heavy_plus_sign', 'hearts', '+1', 'white_check_mark', 'clap', 'mega', 'zap', 'fire', 'hammer_and_wrench'],
})
